import _ from 'lodash'
import { ProposalBlock, ProposalSection } from '@vzmi/shp_shared_compo'
import { HyperLink } from '../../../../Common/Form'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { getNotfoundListingIds } from '../../../helper/batch'
import styles from './index.css'

const NotFoundListingSection = props => {
  const {
    listingIdsFromUrl,
    listings = [],
    deletedListings = [],
    isVisible
  } = props
  const totalListings = [
    ...listings,
    ...deletedListings
  ]
  const listingIds = getNotfoundListingIds(totalListings, listingIdsFromUrl)
  if (!isVisible || _.isEmpty(listings) || _.isEmpty(listingIds)) {
    return null
  }

  const idsStr = _.join(listingIds, COMMA)
  return (
    <ProposalSection
      title='查無賣場'
      data-role='listings-not-found'
      warning
    >
      <ProposalBlock warning>
        <span className={styles.notFoundIds}>
          {`查無賣場 ${idsStr}，您可移至`}
        </span>
        <HyperLink
          target='_blank'
          href={`/listing/query?id=${idsStr}&idType=listing&page=1`}
        >
          賣場查詢
        </HyperLink>
        確認
      </ProposalBlock>
    </ProposalSection>
  )
}

export default NotFoundListingSection
